<template>
  <div class="vat-table-container">
    <table class="vat-table" border="1" style="table-layout: auto">
    <thead>
    <tr>
      <th>{{ $t('vat.table.header.no') }}</th>
      <th>{{ $t('vat.table.header.indicator') }}</th>
      <th class="d-flex flex-column align-items-center justify-content-center">
        <span>{{ $t('vat.table.header.valueOfGoodsAndServices') }}</span>
        <span>({{ $t('vat.table.header.excludingValueAddedTax') }})</span>
      </th>
      <th>{{ $t('vat.table.header.valueAddedTax') }}</th>
    </tr>
    </thead>
    <tbody>
    <tr :key="index" v-for="(row, index) in layout" :class="generateClass(row)">
      <td>
        <p class="mb-0 text-center">
          {{ row.stt }}
        </p>
      </td>
      <th :colspan="generateColSpan(row)">
        <p class="mb-0">
          {{ row.description }}
        </p>
      </th>
      <td v-if="row.id && row.id[0]">
        <b-input-group v-if="row.isCheckbox" :prepend="`[${row.id[0].slice(2)}]`">
          <div class="w-75 d-flex align-items-center justify-content-center">
            <b-form-checkbox v-model="data[row.id[0]]" @change="val => onChangeCt21(val)" :disabled="isEditable(row)"/>
          </div>
        </b-input-group>
        <vat-currency-input
          v-else
          :value.number="data[row.id[0]]"
          @input="row.editable && updateValue(row.id[0], $event)"
          :disabled="isEditable(row)"
          :prepend="`[${row.id[0].slice(2)}]`"
          :onBeforeInput="(e) => onBeforeInput(row.id[0], e)"
        />
      </td>
      <td v-if="row.id && (row.id[0] || row.id[1])">
        <vat-currency-input
          v-if="row.id[1]"
          :prepend="`[${row.id[1].slice(2)}]`"
          :value.number="data[row.id[1]]"
          @input="row.editable && updateValue(row.id[1], $event)"
          :disabled="isEditable(row)"
          :onBeforeInput="(e) => onBeforeInput(row.id[1], e)"
        />
      </td>
    </tr>
    </tbody>
  </table>
  </div>
</template>
<script>
import ExpressionEvaluatorService from '@/utils/expression-evaluator';
import VatCurrencyInput from './vat-currency-input';
import { vatFormLayout, vatFormData } from './index';

export default {
  name: 'vat-return-table',
  components: { VatCurrencyInput },
  props: {
    defaultData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      data: Object.assign({}, JSON.parse(JSON.stringify(vatFormData)), this.defaultData),
      layout: vatFormLayout(this),
      evaluator: new ExpressionEvaluatorService(),
    };
  },
  methods: {
    isEditable(field) {
      return (
        typeof field.editable === 'function'
        ? !field.editable({ data: this.data, $t: this.$t })
        : !field.editable
      );
    },
    onChangeCt21(val) {
      if (val === true) {
        this.data.ct21 = false;
        this.$modal.show('dialog', {
          title: 'Thông báo',
          text: 'NNT chỉ được kê khai các chỉ tiêu: [22], [37], [38], [39a], [40b], [42]. Các chỉ tiêu còn lại khóa không cho kê khai. Bạn có tiếp tục thực hiện không?',
          okText: 'Đồng ý',
          cancelText: 'Không',
          onOk: async () => {
            this.data.ct21 = true;
          },
        });
      }
    },
    generateClass(row) {
      let className = '';

      if (row.bolded) {
        className += 'font-weight-bold';
      } else {
        className += 'font-weight-normal';
      }

      if (!row.editable) {
        className += ' immutable';
      }

      return className;
    },
    generateColSpan(row) {
      if (!row.id) return 3;

      const hasId0 = Boolean(row.id[0]);
      const hasId1 = Boolean(row.id[1]);

      if (!hasId0 && !hasId1) return 3;
      if (!hasId0) return 2;
      return 1;
    },
    onBeforeInput(id, $event) {
      if (!$event.data) return;

      const currentValue = this.data[id] || '';
      const newChar = $event.data || '';
      const inputElement = $event.target;

      const selectionStart = inputElement.selectionStart;
      const selectionEnd = inputElement.selectionEnd;

      const newValue = [
        currentValue.toString().slice(0, selectionStart),
        newChar,
        currentValue.toString().slice(selectionEnd),
      ].join('');

      const currentRow = this.layout.find(row => row.operator && row.id[1] === id);
      if (!currentRow) return;

      const virtualData = { ...this.data, [id]: Number(newValue) };

      try {
        Object.entries(currentRow.operator).forEach(([_, expressionTokens]) => {
          const isValid = this.evaluator.evaluate(expressionTokens, virtualData);
          if (Number(isValid) === 0) {
            $event.preventDefault();
          }
        });
      } catch (err) {
        console.warn(`Failed to evaluate condition for ${id}:`, err.message);
        $event.preventDefault();
      }
    },
    updateValue(id, $event) {
      if (!$event) {
        this.data[id] = 0;
      } else {
        this.data[id] = Math.abs($event);
      }

      this.layout.forEach((row) => {
        let show = 1;
        if (row.show && row.id) {
          Object.entries(row.show).forEach(([fieldKey, expressionTokens]) => {
            try {
              show = this.evaluator.evaluate(expressionTokens, this.data);
            } catch (err) {
              console.warn(`Failed to evaluate ${fieldKey}:`, err.message);
            }
          });
        }
        if (row.dependsOn && row.id) {
          Object.entries(row.dependsOn).forEach(([fieldKey, expressionTokens]) => {
            if (fieldKey !== id) {
              try {
                if (show) {
                  this.data[fieldKey] = this.evaluator.evaluate(expressionTokens, this.data);
                } else {
                  this.data[fieldKey] = 0;
                }
              } catch (err) {
                console.warn(`Failed to evaluate ${fieldKey}:`, err.message);
              }
            }
          });
        }
      });
    },
    getValues() {
      return this.data;
    },
  },
};
</script>
<style lang="scss">
.vat-table-container {
  --background: #E9EFFD;
  --rounded: .625rem;
  --primary: #005DCA;
  --text-sm: 0.875rem; // 14px

  overflow: auto;
  height: 100%;
  width: 100%;
  .vat-table {
    border: none;
    border-spacing: 0 8px;
    td, th {
      border: 1px solid var(--primary);
      padding: 0.4rem;
      font-size: 14px;
      vertical-align: middle;
    }
    thead {
      tr {
        th {
          text-align: center;
          color: var(--primary);
          border: none;
          border-bottom: 1px solid var(--primary);
        }
      }
    }
    tbody {
      tr {
        td, th {
          border-top: none;
          font-weight: normal;
          margin-bottom: 8px;
          background-color: transparent;
        }
        td {
          .input-group {
            justify-content: center;
            align-items: center;
            .input-group-prepend {
              .input-group-text {
                font-size: var(--text-sm);
                border-top-left-radius: var(--rounded);
                border-bottom-left-radius: 0.625rem;
              }
            }
            .form-control {
              border-top-left-radius: 0 !important;
              border-bottom-left-radius: 0 !important;
            }
          }
        }
        td:first-of-type {
          //border-radius: var(--rounded) 0 0 var(--rounded);
        }
        td:last-of-type {
          //border-radius: 0 var(--rounded) var(--rounded) 0;
        }
      }
      tr.font-weight-bold {
        td, th {
          font-weight: bold;
        }
        td {
          .input-group {
            .input-group-prepend {
              .input-group-text {
                font-weight: bold;
              }
            }
            .form-control {
              font-weight: bold;
            }
          }
        }
      }
      tr.immutable{
        td, th {
          background-color: var(--background);
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/portal-components/value-added-tax/vat-return/vat-return-table/vat-return-table.vue